import { create } from 'zustand'

interface DragAndDropStoreType {
    isDragging: boolean
    actions: {
        setIsDragging: (isDragging: boolean) => void
    }
}

export const useDragAndDropStore = create<DragAndDropStoreType>()((set) => ({
    isDragging: false,
    actions: {
        setIsDragging: (isDragging: boolean) => set({ isDragging }),
    },
}))

// State selector
export const useIsDragging = () =>
    useDragAndDropStore((state) => state.isDragging)

// Actions selector
export const useDragAndDropActions = () =>
    useDragAndDropStore((state) => state.actions)
